// components/MetricCard.jsx
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export default function MetricCard({ title, value, change, positive }) {
  return (
   <div className="bg-[#EBF4F9] dark:bg-[rgba(53,135,184,0.4)] dark:backdrop-blur-lg rounded-xl shadow-md p-4 w-full space-y-1">
  <div className="text-sm text-[#0D141C] dark:text-white font-medium">{title}</div>
  <div className="text-xl font-bold text-[#0D141C] dark:text-white">{value}</div>
  <div className={`text-sm flex items-center ${positive ? "text-green-600" : "text-red-500"}`}>
    {positive ? (
      <ArrowDropUpIcon fontSize="small" />
    ) : (
      <ArrowDropDownIcon fontSize="small" />
    )}
    <span>{change}</span>
  </div>
</div>

  );
}

